import { Box, Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CarousalItems, { IMediaItems } from './carousalItems';

type Props = {
  mediaItems: IMediaItems[];
  activeIndex?: number;
  fullscreen: boolean;
  closeFullScreen: () => void;
  videoMedia?: boolean;
  enableZoom: boolean;
};

const FullScreenView = ({
  mediaItems,
  activeIndex = 0,
  fullscreen,
  closeFullScreen,
  videoMedia,
  enableZoom
}: Props) => {

  return (
    <Dialog
      fullScreen
      open={fullscreen}
      PaperProps={{
        elevation: 0
      }}
    >
        <Box sx={{ flex: '75%', position: 'relative'}}>
        {/* Close Button */}
        <IconButton
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            color: '#fff',
            zIndex: 1000,
            backgroundColor: 'rgba(0, 0, 0, 0.6)'
          }}
          onClick={closeFullScreen}
        >
          <CloseIcon />
        </IconButton>

        {/* Carousel Items */}
        <CarousalItems
          fullScreenView
          mediaDtos={mediaItems}
          activeIndex={activeIndex}
          sx={{
            height: '100vh',
            transition: 'transform 0.3s ease'
          }}
          imgSx={{
            height: '100vh',
            maxWidth: '100%',
            width: '100%',
            objectFit: 'contain'
          }}
          videoSx={{
            height: '100vh'
          }}
          enableZoom={enableZoom}
        />
      </Box>
    </Dialog>
  );
};

export default FullScreenView;
